import { Node } from 'tiptap';
import {
  tableEditing,
  columnResizing,
  goToNextCell,
  addColumnBefore,
  addColumnAfter,
  deleteColumn,
  addRowBefore,
  addRowAfter,
  deleteRow,
  deleteTable,
  mergeCells,
  splitCell,
  toggleHeaderColumn,
  toggleHeaderRow,
  toggleHeaderCell,
  setCellAttr,
  fixTables,
} from 'prosemirror-tables';
import { selectTable, createTable } from 'prosemirror-utils';
import { TextSelection } from 'prosemirror-state';
import TableNodes from './table-nodes';

export default class TableNode extends Node {
  get name() {
    return 'table';
  }

  options = {
    resizable: false,
    resizeOptions: {},
  };

  constructor(options: {
    resizable?: boolean;
    resizeOptions?: {
      handleWidth?: number;
      cellMinWidth?: number;
      lastColumnResizable?: boolean;
    };
  }) {
    super(options);

    this.options = {
      ...this.options,
      ...options,
    };
  }

  get schema() {
    return TableNodes.table;
  }

  commands({ schema }) {
    return {
      createTable: ({ rowsCount, colsCount, withHeaderRow }) => (state, dispatch) => {
        const offset = state.tr.selection.anchor + 1;

        const nodes = createTable(schema, rowsCount, colsCount, withHeaderRow);
        const tr = state.tr.replaceSelectionWith(nodes).scrollIntoView();
        const resolvedPos = tr.doc.resolve(offset);

        tr.setSelection(TextSelection.near(resolvedPos));

        dispatch(tr);
      },
      addColumnBefore: () => addColumnBefore,
      addColumnAfter: () => addColumnAfter,
      deleteColumn: () => deleteColumn,
      addRowBefore: () => addRowBefore,
      addRowAfter: () => addRowAfter,
      deleteRow: () => deleteRow,
      deleteTable: () => deleteTable,
      toggleCellMerge: () => (state, dispatch) => {
        if (mergeCells(state, dispatch)) {
          return;
        }
        splitCell(state, dispatch);
      },
      mergeCells: () => mergeCells,
      splitCell: () => splitCell,
      toggleHeaderColumn: () => toggleHeaderColumn,
      toggleHeaderRow: () => toggleHeaderRow,
      toggleHeaderCell: () => toggleHeaderCell,
      setCellAttr: () => setCellAttr,
      fixTables: () => fixTables,
    };
  }

  keys() {
    return {
      Tab: goToNextCell(1),
      'Shift-Tab': goToNextCell(-1),
      'Mod-a': (state, dispatch) => {
        dispatch(selectTable(state.tr));
        return true;
      },
    };
  }

  get plugins() {
    return [
      ...(this.options.resizable ? [columnResizing(this.options.resizeOptions)] : []),
      tableEditing(),
    ];
  }
}
